'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { UNARCHIVED_CONTENT } from '../actions/ActionTypes';
import { receiveContent, requestedUnarchiveContentFailure, requestedUnarchiveContentSuccess, requestUnarchiveContent } from '../actions/ContentActions';
import { closeModal } from '../actions/ModalActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(UNARCHIVED_CONTENT).pipe(mergeMap(({
  payload: {
    contentType,
    id
  }
}) => ContentClient.unarchiveContent(contentType, id).pipe(mergeMap(content => of(receiveContent(content), closeModal(), requestedUnarchiveContentSuccess(contentType))), catchError(error => of(requestedUnarchiveContentFailure(error, contentType))), startWith(requestUnarchiveContent())))));